import { PriceItem } from "@silversea-ssc/ui-components-react";
import {
  perGuestLabel,
  transformPriceFrom,
  withLowestFareAvailableLabel
} from "components/Prices/utils";
import React from "react";
import { EnhancedAvailablePriceWithFareCode } from "src/ssc-api/prices/types";
import { isPresent } from "src/utils/checks";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import * as styles from "./StickyCruisePrice.module.scss";
import { useLingui } from "@lingui/react/macro";
import { useStaticFareLabels } from "features/fare/use-static-fare-labels";

type Props = {
  price: EnhancedAvailablePriceWithFareCode | undefined;
  departureDate?: string;
};

const StickyCruisePrice: React.FC<Props> = ({ price }) => {
  const geolocation = useGeolocation();
  const { fareCodeLabel } = useStaticFareLabels();
  const { t } = useLingui();

  const transformedPrice = transformPriceFrom(
    t,
    price,
    geolocation.defaultCurrency,
    true,
    "only-from",
    fareCodeLabel
  );
  const isWaitlist = price?.type == "waitlist";

  if (!isPresent(price)) return null;

  return (
    <div className={styles.container}>
      <PriceItem
        price={transformedPrice}
        variant="small"
        layout="row"
        showFareLabel
        chipBackgroundColor="neutral05"
        perGuestLabel={t(perGuestLabel())}
        priceType="primary"
      />
      {!isWaitlist && (
        <div className={styles.bottomLabel}>
          {t(withLowestFareAvailableLabel())}
        </div>
      )}
    </div>
  );
};

export default StickyCruisePrice;
